import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROOT_DIR, LOCATION} from '../../utils/Constants';

class HomepageFeatures extends Component {
  render(){

    return(
      <div>
        <div className="row">
          <div className="large-12 columns">
            <article className="feature-item">
              <Link to="/getfound"><img className="logo" src={`${ROOT_DIR}/assets/img/logo.png`} alt={`Find and get found on ${LOCATION} Online`}/></Link>
              <h2 className="no-margin feature-heading">{LOCATION} Online - local business and event listings</h2>
              <p>{LOCATION} Online is the place to go to find local businesses, services and events. In addition to being a business directory for {LOCATION}, we also offer the you opportunity to promote your business or event here for free. If your business is not in our current list or you are interested in having it featured on the home page or in a prominent position on the listing pages, or if you have an event you would like to promote, please <Link to="/getfound">send us your information</Link>. We will give your listing premium exposure for FREE if you submit it <span className="bold">now</span>. <Link to="/getfound" className="bold">Get found!</Link></p>
            </article>
          </div>
        </div>
      </div>
    );
  }
}
export default HomepageFeatures;


// WEBPACK FOOTER //
// ./src/components/blocks/HomepageFeatures.js